// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u8().primaryKey(),
  totalEvents: __t.u64().name("total_events"),
  lastEventAt: __t.u64().name("last_event_at"),
  currentSecondCount: __t.u32().name("current_second_count"),
  currentSecond: __t.u64().name("current_second"),
  lastSecondCount: __t.u32().name("last_second_count"),
});
